import { type AppState } from 'src/redux/app/app.store'

export const selectCurrentUser = (state: AppState) => state.auth.user
export const selectCurrentUserRoles = (state: AppState) => state.auth.roles
export const selectIsAuthenticated = (state: AppState) => state.auth.isAuthenticated
export const selectAuthError = (state: AppState) => state.auth.authError
